import {Pipe, PipeTransform} from '@angular/core';
import { Mid } from 'src/app/constants/mids';
import { getEntityMid } from 'src/app/helpers/getEntityMid';
import { BrandImgConstants, BrandImgShortConstants } from './barand-img.constatns';

@Pipe({name: 'brandImg'})
export class BrandImgPipe implements PipeTransform {
  constructor() {
  }

  transform(entity, product, type: 'short' | 'full' = 'full'): string | null{
    if (!entity) return;

    let campaign_source = entity.campaign_source;

    if (!campaign_source) return;
    campaign_source = campaign_source.toLowerCase();

    let imgs = BrandImgConstants;

    if(type === 'short') {
      imgs = BrandImgShortConstants;
    }

    if (campaign_source.includes('usa dv') || getEntityMid(entity, product) === Mid.USA_DV) {
      return imgs[Mid.USA_DV];
    }

    if (getEntityMid(entity, product) === Mid.CMG) {
      return imgs[Mid.CMG];
    }

    if (getEntityMid(entity, product) === Mid.VDC) {
      return imgs[Mid.VDC];
    }

    if (getEntityMid(entity, product) === Mid.BCN) {
      return imgs[Mid.BCN];
    }

    if (getEntityMid(entity, product) === Mid.MDC) {
      return imgs[Mid.MDC];
    }

    if (getEntityMid(entity, product) === Mid.ACX) {
      return imgs[Mid.ACX];
    }

    if (getEntityMid(entity, product) === Mid.AUMG) {
      return imgs[Mid.AUMG];
    }

    return imgs[Mid.CV];
  }
}
